export default {"src":"/_next/static/media/blunder.3cab4ae5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};